module.exports = __webpack_public_path__ + "static/img/tunnel-text-4.5e2ed840.png";